import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  INITIATE_AUTHOR_CONTENT,
  COMPLETE_AUTHOR_CONTENT,
  SHOW_PRODUCT_SELECTION_OPTIONS,
  SHOW_UCIDN_LIST_OPTIONS,
  SHOW_PRODUCT_SELECTION_OPTIONS_CHANGE,
  PRODUCT_SELECTION_ERROR,
} from '../app-constants';
import { getAEMContent, loadSelectedProduct, getAEMContentForPurlApps, getProductSelectionForUCidnSelection } from './authorable-content.actions';
import AuthorableContentView from './authorable-content.presenter';
import { getSecureAuthToken } from '../auth/auth.actions';
// Reducer
export const authorableContentReducer = (state = {
  loading: true,
  showProductSelection: false,
  showAccountProductChange: false,
  showUCidnList: false,
  productError: false,
  productSelectionList: [],
  uCidnSelectionList: [],
  accountKey: '',
  authorableContent: {
    routePaths: null,
    marketComparison: null,
    homePage: null,
  },
}, action) => {
  switch (action.type) {
    case INITIATE_AUTHOR_CONTENT:
      return { ...state, loading: true, showProductSelection: false };
    case SHOW_PRODUCT_SELECTION_OPTIONS:
      return { ...state, showProductSelection: true, productSelectionList: action.data };
    case SHOW_PRODUCT_SELECTION_OPTIONS_CHANGE:
      return { ...state, productSelectionList: action.data };
    case SHOW_UCIDN_LIST_OPTIONS:
      return { ...state, showUCidnList: true, uCidnSelectionList: action.data };
    case PRODUCT_SELECTION_ERROR:
      return { ...state, productError: true };

    case COMPLETE_AUTHOR_CONTENT: {
      return { ...state, loading: false, showProductSelection: false, showUCidnList: false, authorableContent: action.data };
    }
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  authorableContent: state.authorableContentReducer.authorableContent,
  secureAuthAuthenticated: state.dataBootStrapReducer.secureAuthAuthenticated,
  contentLoading: state.authorableContentReducer.loading,
  showProductSelection: state.authorableContentReducer.showProductSelection,
  productSelectionList: state.authorableContentReducer.productSelectionList,
  showUCidnList: state.authorableContentReducer.showUCidnList,
  uCidnSelectionList: state.authorableContentReducer.uCidnSelectionList,
  accountKey: state.authorableContentReducer.accountKey,
  showAccountProductChange: false,
  productError: state.authorableContentReducer.productError,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getAEMContent,
    loadSelectedProduct,
    getAEMContentForPurlApps,
    getProductSelectionForUCidnSelection,
    getSecureAuthToken,
  }, dispatch),
});

const AuthorableContent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthorableContentView);

export default AuthorableContent;

